import { usePrefetchTriggers } from "@ui/hooks/use-prefetch-triggers";
import type { PrefetchProps, PrefetchTrigger } from "@ui/lib/prefetch-context";
import { mergeProps } from "react-aria";
import { Link as RACLink, type LinkProps as RACLinkProps } from "react-aria-components";

export type { PrefetchTrigger };

export interface LinkProps extends RACLinkProps, PrefetchProps {}

const EMPTY_HANDLERS = Object.freeze({});

export function Link(props: LinkProps) {
  const { prefetch, cacheFor, cacheTags, ...rest } = props;
  const href = typeof rest.href === "string" ? rest.href : undefined;
  const { hoverHandlers, pressHandlers } = usePrefetchTriggers(href, { prefetch, cacheFor, cacheTags });

  const merged = mergeProps(rest, hoverHandlers ?? EMPTY_HANDLERS, pressHandlers ?? EMPTY_HANDLERS);

  return <RACLink {...merged} />;
}
